import { createAsyncThunk } from "@reduxjs/toolkit";
import { ResourcesService } from "@services/index";
import { getBaseUrl } from "../selectors/features";
import {
  FETCH_RESOURCES,
  DELETE_RESOURCES,
  ADD_RESOURCES,
} from "@root/store/action-types";


const resourcesService = new ResourcesService();

export const getResources = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(FETCH_RESOURCES, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload } = requestPayload;

  const { data, error } = await resourcesService.getResources(
    baseUrl,
    payload
  );

  if (error) {
    onError(error, FETCH_RESOURCES);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, FETCH_RESOURCES);
  }
  return thunkAPI.fulfillWithValue(data);
});

export const doAddResources = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(ADD_RESOURCES, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload } = requestPayload;

  const { data, error } = await resourcesService.addResource(
    baseUrl,
    payload
  );
  if (error) {
    onError(data, ADD_RESOURCES);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, ADD_RESOURCES);
  }
  return thunkAPI.fulfillWithValue(data);
});

export const deleteResource= createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(DELETE_RESOURCES, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, id, paymentRemovalSuccess } = requestPayload;

  const { data, error,statusCode} = await resourcesService.deleteResource(
    baseUrl,
    id
  );


  if (statusCode===200 || statusCode===204) {
    onSuccess(data, DELETE_RESOURCES, paymentRemovalSuccess);
    
    return thunkAPI.rejectWithValue(error);
  } else {
    onError(error, DELETE_RESOURCES);
    
  }
  return thunkAPI.fulfillWithValue(data);
});

